import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { ContactUs } from "shared/components/Auth/ContactUs";
import { ComponentReviews } from "shared/components/ComponentReviews";

import "@brandAssets/scss/reviews.scss";
import "i18n";
import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

if (document.getElementById("reviews__trigger")) {
  ReactDOM.createRoot(document.getElementById("reviews__trigger")).render(
    <ErrorBoundary>
      <ComponentReviews />
    </ErrorBoundary>
  );
}

if (document.getElementById("contact_us")) {
  ReactDOM.createRoot(document.getElementById("contact_us")).render(
    <ErrorBoundary>
      <ContactUs isReviewsForm />
    </ErrorBoundary>
  );
}

reportWebVitals(console.log);
